var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-formats"},[_c('h2',{staticClass:"title"},[_vm._v("FORMATO")]),_c('div',{staticClass:"formats"},_vm._l((_vm.formats),function(format){return _c('button',{key:format.CODFORMATO,staticClass:"btn btn-light",on:{"click":_vm.selectFormat}},[_vm._v(_vm._s(format.DESCRIPCION))])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92acb356","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/OrderAddProductModal/ProductFormats.vue
// module id = null
// module chunks = 